import styled from 'styled-components';

// Linha de contexto acima da lista: o total e o proximo disparo programado.
// Vive dentro do painel porque o cabecalho do modal ja esta ocupado com o
// resumo do contrato, que vale para todas as abas.
export const ReguaTopo = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 24px;
  margin-bottom: 12px;
  flex-shrink: 0;
`;

export const ReguaHint = styled.span`
  font-size: 12px;
  color: #718096;
`;

// A rolagem fica aqui dentro, como na linha do tempo: o modal tem altura fixa
// e nao pode mudar de tamanho conforme o filtro selecionado.
export const ListaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 4px 4px 8px 4px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const ListaFallback = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px 0;
`;

// Cada disparo e um card, na mesma linguagem visual dos cards de resumo do
// menu Cobranca: fundo branco, borda fina e tarja colorida a esquerda — aqui
// a cor vem do status do disparo.
export const DisparoCard = styled.div`
  background: white;
  border: 1px solid #e2e8f0;
  border-left: 4px solid ${(props) => props.$color || '#2670d1'};
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
  margin-bottom: 10px;
`;

export const PassoTag = styled.span`
  background: ${(props) => props.$color || '#2670d1'};
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  border-radius: 4px;
  padding: 2px 8px;
  white-space: nowrap;
`;

export const PassoTitulo = styled.span`
  font-size: 14px;
  color: #2d3748;
  flex: 1;
  min-width: 120px;
`;

export const StatusBadge = styled.span`
  font-size: 12px;
  color: ${(props) => props.$color || '#2670d1'};
  border: 1px solid ${(props) => props.$color || '#2670d1'};
  background: ${(props) => props.$color || '#2670d1'}14;
  border-radius: 16px;
  padding: 2px 10px;
  white-space: nowrap;
`;

export const CamposContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
`;

export const CampoItem = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const CampoLabel = styled.span`
  font-size: 11px;
  text-transform: uppercase;
  color: #718096;
  white-space: nowrap;
`;

export const CampoValue = styled.span`
  font-size: 14px;
  color: #2d3748;
`;

export const ErroNota = styled.div`
  margin-top: 10px;
  font-size: 12px;
  color: #a02a22;
  background: #ff3b3010;
  border-radius: 4px;
  padding: 6px 10px;
`;

// Disparo cancelado usa o mesmo campo `erro` do backend, mas ali ele não é
// falha: é o motivo de o aviso não ter saído ("Contrato enviado para
// Execução"). Em vermelho o operador lê como problema, então o cancelado
// ganha a nota neutra.
export const MotivoNota = styled.div`
  margin-top: 10px;
  font-size: 12px;
  color: #4a5568;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 6px 10px;
`;

export const MotivoLabel = styled.span`
  text-transform: uppercase;
  font-size: 11px;
  color: #718096;
  margin-right: 6px;
`;
